import baseStyled, { ThemedStyledInterface } from 'styled-components';

const theme = {
  primaryTextColor: 'hsl(0, 0%, 13%)',
  secondaryTextColor: 'hsl(0, 0%, 29%)',
  terciaryTextColor: 'hsl(0, 0%, 45%)',

  primaryColor: '#4975A0',
  terciaryColor: '#F27128',

  billingCardsStackEndpoint: '768px',

  mainContentPadding: '12px',

  padding1: '4px',
  padding2: '8px',
  padding3: '12px',
  padding4: '16px',
  padding5: '24px',
  padding6: '32px',
  padding7: '48px',
  padding8: '64px',
  padding9: '96px',
  padding10: '128px',
  padding11: '192px',
  padding12: '256px',
  padding13: '384px',
  padding14: '512px',
  padding15: '640px',
  padding16: '768px',
};

export type Theme = typeof theme;
export default theme;
export const styled = baseStyled as ThemedStyledInterface<Theme>;
